import { render, staticRenderFns } from "./StageFormTemplate.vue?vue&type=template&id=78f156ae&scoped=true"
import script from "./StageFormTemplate.vue?vue&type=script&lang=js"
export * from "./StageFormTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f156ae",
  null
  
)

export default component.exports